const toBase64 = (bytes) => btoa(String.fromCharCode(...new Uint8Array(bytes)));

export async function encryptLoginCredentials(apiUri, credentials) {
  const response = await fetch(`${apiUri}/login/public-key`, { cache: "no-store" });
  if (!response.ok) throw new Error("No se pudo obtener la clave de login");
  const { public_key } = await response.json();
  const der = Uint8Array.from(
    atob(public_key.replace(/-----[^-]+-----/g, "").replace(/\s/g, "")),
    (character) => character.charCodeAt(0),
  );
  const publicKey = await window.crypto.subtle.importKey(
    "spki", der, { name: "RSA-OAEP", hash: "SHA-256" }, false, ["encrypt"],
  );
  const key = await window.crypto.subtle.generateKey(
    { name: "AES-GCM", length: 256 }, true, ["encrypt"],
  );
  const iv = window.crypto.getRandomValues(new Uint8Array(12));
  const ciphertext = await window.crypto.subtle.encrypt(
    { name: "AES-GCM", iv }, key,
    new TextEncoder().encode(JSON.stringify(credentials)),
  );
  const encryptedKey = await window.crypto.subtle.encrypt(
    { name: "RSA-OAEP" }, publicKey,
    await window.crypto.subtle.exportKey("raw", key),
  );
  return {
    encrypted_key: toBase64(encryptedKey),
    iv: toBase64(iv),
    ciphertext: toBase64(ciphertext),
  };
}
